import React, { useState, useRef } from "react"
import styled from "styled-components"

import WrappedCard from "components/molecules/WrappedCard"
import ImageCard from "components/molecules/ImageCard"
import Link from "components/utils/Link"
import Box from "components/atoms/Box"
import FlexBox from "components/atoms/Flex"
import { Text, Paragraph } from "components/atoms/Typography"
import Button from "components/atoms/Button"
import { colors } from "utils/styled-constants"

const NameCardWrapper = styled("div")`
  position: relative;
  display: flex;
  bottom: 0;
  left: 0;
  width: 100%;
`

const NewsTextCard = ({ title, newsType, dateString }) => {
  return (
    <Box width="100%" padding={4} pt={3}>
      <FlexBox width="100%" justifyContent="space-between">
        <Text as="p" variant="grid-item-supertitle">
          {newsType}
        </Text>
        <Text as="p" variant="grid-item-supertitle">
          {dateString}
        </Text>
      </FlexBox>
      <Text as="p" mt={3}>
        {title}
      </Text>
    </Box>
  )
}

const NewsCard = ({ title, dateString, newsType, link, image }) => {
  const [hoverActive, setHoverActive] = useState(false)

  const cardRef = useRef(null)

  return (
    <WrappedCard
      style={{
        position: "relative",
        alignItems: "center",
        "&:hover": {
          boxShadow: "none !important",
        },
      }}
      height="100%"
      flexDirection="column"
      justifyContent="stretch"
      onMouseEnter={() => setHoverActive(true)}
      onMouseLeave={() => setHoverActive(false)}
      width={"100%"}
      mx="auto"
      ref={cardRef}
    >
      <a
        style={{ maxWidth: "400px" }}
        href={link}
        rel="noreferrer noopener"
        target="_blank"
      >
        <Box>
          <ImageCard image={image} />
        </Box>
        <NameCardWrapper hoverActive={hoverActive}>
          <NewsTextCard
            dateString={dateString}
            title={title}
            newsType={newsType}
          />
        </NameCardWrapper>
      </a>
    </WrappedCard>
  )
}

export default NewsCard

export const query = graphql`
  fragment Post on ContentfulPost {
    title
    tags {
      label
    }
    image {
      fluid(maxWidth: 600, quality: 90) {
        ...GatsbyContentfulFluid_withWebp
      }
    }
    date
    dateString: date(formatString: "MMM DD, YYYY")
    link
    newsType
  }
`
